// extracted by mini-css-extract-plugin
module.exports = {"default":"idt-sizeattributelabel_default__1ws7k","subText":"idt-sizeattributelabel_subtext__1bew5"};